import { render } from "./ExpertPage.vue?vue&type=template&id=82260784"
import script from "./ExpertPage.vue?vue&type=script&lang=js"
export * from "./ExpertPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__